import { useMemo, useState } from "react";

export const useSortableData = (items, initialKey, initialDir = "desc") => {
    const [sortKey, setSortKey] = useState(initialKey);
    const [sortDir, setSortDir] = useState(initialDir);

    const sorted = useMemo(() => {
        const arr = [...(items || [])];
        arr.sort((a, b) => {
            const av = a[sortKey];
            const bv = b[sortKey];
            if (typeof av === "number" && typeof bv === "number") {
                return sortDir === "asc" ? av - bv : bv - av;
            }
            return sortDir === "asc"
                ? String(av).localeCompare(String(bv))
                : String(bv).localeCompare(String(av));
        });
        return arr;
    }, [items, sortKey, sortDir]);

    const toggle = (key) => {
        if (key === sortKey) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("desc");
        }
    };

    return { sorted, sortKey, sortDir, toggle };
};
